import { useRef, useState } from "react";
import { handleAddToResources, handleSetDefaultSelectedItem, handleSetLinkUploadModalStatus } from "../../../fileManager.actions";
import TextInput from "../../../../textInput/textInput.index";
import { ButtonSize, ButtonType } from "../../../../button/button.interface";
import Button from "../../../../button/button.index";
import Dialog from "../../../../dialog/dialog.index";
import { advancedResponseValidator, post } from "../../../../../../scripts/api";
import API from "../../../../../../urls/api";
import { getFileManagerParent, getFileManagerParentId, getWebEnvConfig, isValidUrl, UnitConvertStandard } from "../../../../../../scripts/helpers";
import { LinkUploadStatus, ResourceType } from "../../../../../../interfaces/general";
import store from "../../../../../../redux/store";
import { toast } from "mobin-toast";
import { ENVIRONMENT } from "../../../../../../environment";
import info from "../../../../../../assets/images/icons/info.svg";
import { toastMessages } from "../../../../../../scripts/toastMessages";
import { shallowEqual } from "react-redux";
import { useAppSelector } from "../../../../../../redux/hooks";

export default function LinkUploadModal(): JSX.Element {
    const buttonRef = useRef<any>();
    const { linkUploadModalStatus } = useAppSelector(({ fileManager: { linkUploadModalStatus } }) => ({ linkUploadModalStatus }), shallowEqual);
    const [linkValue, setLinkValue] = useState<string>("");
    const [name, setName] = useState("");

    const addLinkUploadUrl = (linkUpload: string) => {
        handleSetDefaultSelectedItem([]);
        const user = store.getState().auth.user;
        if (isValidUrl(linkUpload)) {
            return new Promise((resolve) => {
                post(
                    (data, status) => {
                        if (advancedResponseValidator(data, status)) {
                            handleSetLinkUploadModalStatus(false);
                            setLinkValue("");
                            setName("");
                            if (data.detail) {
                                toast({ title: toastMessages(91), type: "error" });
                            } else {
                                toast({ title: toastMessages(92), type: "success" });
                                const newResourceUploadLink: ResourceType = {
                                    id: data.id,
                                    name: name ? name : linkValue,
                                    download_url: "",
                                    folder_metadata: null,
                                    key: "uploadLink",
                                    size: 0,
                                    is_complete: true,
                                    level: 0,
                                    user: user!,
                                    has_cover: false,
                                    last_modified: Math.floor(Date.now() / 1000),
                                    created_at: Math.floor(Date.now() / 1000),
                                    is_favorite: false,
                                    has_link: false,
                                    is_shared: false,
                                    from_link: true,
                                    parent: getFileManagerParent(),
                                    linkUploadStatus: LinkUploadStatus.NEW
                                };
                                handleSetDefaultSelectedItem([]);
                                handleAddToResources(newResourceUploadLink);
                            }
                        }
                        resolve(true);
                    },
                    API.storage.add(),
                    {
                        url: linkUpload,
                        name: name,
                        parent: getFileManagerParentId()
                    }
                );
            });
        } else {
            toast({ type: "error", title: toastMessages(94) });
        }
    };

    return (
        <Dialog
            status={linkUploadModalStatus}
            onClose={() => {
                handleSetLinkUploadModalStatus(false);
                setLinkValue("");
                setName("");
            }}
            title="آپلود از طریق لینک"
        >
            <div
                className="p-4 pt-0"
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        buttonRef.current.click();
                    } else if (e.key === "Escape") {
                        handleSetLinkUploadModalStatus(false);
                        setLinkValue("");
                        setName("");
                    }
                }}
            >
                <span className="mt-2 mb-4 text-[14px] text-secondary-500 block">
                    شما می‌توانید لینک مستقیم فایل موردنظر خود را کپی کرده و در این قسمت وارد کنید و منتظر آپلود آن در {ENVIRONMENT.brandName} باشید.
                </span>
                <div>
                    <TextInput
                        label="لینک"
                        placeholder=".لینک فایل موردنظر را وارد کنید"
                        autoFocus={true}
                        onChange={(value) => {
                            setLinkValue(value);
                        }}
                        value={linkValue}
                    />
                    <div className="flex items-center gap-2 mt-2">
                        <img src={info} alt="info" />
                        <span className="text-[14px] text-secondary-500 block">{`حداکثر حجم فایل قابل‌قبول  ${Math.floor(UnitConvertStandard(Number(getWebEnvConfig("UPLOAD_URL_SIZE_LIMIT")), "fa").value)} ${UnitConvertStandard(Number(getWebEnvConfig("UPLOAD_URL_SIZE_LIMIT")), "fa").unit} است.`}</span>
                    </div>
                </div>
                <div className="mt-4">
                    <TextInput
                        label="نام فایل"
                        placeholder=".نام فایل موردنظر را وارد کنید"
                        onChange={(value) => {
                            setName(value);
                        }}
                        value={
                            linkValue && isValidUrl(linkValue)
                                ? decodeURIComponent(
                                      (new URL(linkValue).pathname.split("/").pop()!.split(".").length > 1
                                          ? new URL(linkValue).pathname.split("/").pop()
                                          : "")!
                                  )
                                : name
                        }
                    />
                    <div className="flex items-center gap-2 mt-2">
                        <img src={info} alt="info" />
                        <span className="text-[14px] text-secondary-500 block">
                            در صورت واردکردن نام فایل این نام جایگزین نام فایل لینک آپلود خواهد شد.
                        </span>
                    </div>
                </div>
                <div className="flex items-center gap-4 justify-end mt-8">
                    <Button
                        text="انصراف"
                        size={ButtonSize.MD}
                        className="text-secondary-600 hover:text-secondary-800 w-full"
                        type={ButtonType.TEXT}
                        onClick={() => {
                            handleSetLinkUploadModalStatus(false);
                            setLinkValue("");
                            setName("");
                        }}
                        autoFocus={false}
                    />
                    <Button
                        className="w-full"
                        size={ButtonSize.MD}
                        text="تایید"
                        autoFocus={false}
                        onClick={() => addLinkUploadUrl(linkValue)}
                        ref={buttonRef}
                    />
                </div>
            </div>
        </Dialog>
    );
}
